import { Container, Nav, Navbar } from 'react-bootstrap';
import './script/scrollBehaviour';

function NavScrollExample() {
  return (
    <Navbar
      bg="transparent"
      style={{
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      }}
      expand="lg"
      className="fixed-top"
      id="navigasi"
    >
      <Container>
        {/* Brand + Logo */}
        <Navbar.Brand
          href="/"
          className="fw-bold fs-3 d-flex align-items-center"
          style={{ color: '#1F2937' }}
        >
          <img
            src="/assets/logo.png"
            alt=""
            height="40"
            className="me-2 d-inline-block align-top"
          />
          edcworkss
        </Navbar.Brand>

        {/* Toggle & Links */}
        <Navbar.Toggle />
        <Navbar.Collapse>
          <Nav className="ms-auto my-2 my-lg-0">
            <Nav.Link
              href="#why-us"
              className="me-2 mb-lg-0 mb-2 fw-semibold"
              style={{ color: '#1F2937' }}
            >
              About
            </Nav.Link>
            <Nav.Link
              href="#service"
              className="me-2 mb-lg-0 mb-2 fw-semibold"
              style={{ color: '#1F2937' }}
            >
              Service
            </Nav.Link>
            <Nav.Link
              href="#team"
              className="me-2 mb-lg-0 mb-2 fw-semibold"
              style={{ color: '#1F2937' }}
            >
              Team Gallery
            </Nav.Link>
            <Nav.Link
              href="#portofolio"
              className="me-2 mb-lg-0 mb-2 fw-semibold"
              style={{ color: '#1F2937' }}
            >
              Portofolio
            </Nav.Link>
            <Nav.Link
              href="#models"
              className="me-3 mb-lg-0 mb-2 fw-semibold"
              style={{ 
                color: '#fff',
                background: '#FFD54F',
                borderRadius: '25px',
                padding: '8px 20px',
                marginLeft: '10px'
              }}
            >
              <i className="bi bi-people-fill me-1"></i>
              Models
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavScrollExample;
